 

function Section3() { 

  return (
    
    <div className='grid grid-cols-1 tablet:grid-cols-2'>
        <div>
           <img src='imgs/food2.jpg' className='shadow-[8px_10px_4px_rgba(249,201,130)] object-cover w-80 tablet:w-full mx-auto'/>
        </div>
        <div className='w-1/2 mx-auto'>
            <p className=' text-secondary leading-10 font1 text-justify mt-20 tablet:mt-60'>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
        </div>
    </div>
  )
}

export default Section3